"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ParsedDesc_1 = require("./ParsedDesc");

var MapParser_1 = require("./parsers/MapParser");

var MapDesc =
/*#__PURE__*/
function (_ParsedDesc_1$ParsedD) {
  _inherits(MapDesc, _ParsedDesc_1$ParsedD);

  function MapDesc(members, desc, validators) {
    var _this;

    _classCallCheck(this, MapDesc);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MapDesc).call(this, new MapParser_1.MapParser(members), desc, validators));
    _this.members = members;
    return _this;
  }

  _createClass(MapDesc, [{
    key: "withDescription",
    value: function withDescription(descr) {
      return new MapDesc(this.members, this.mergeDescs(descr), this.validators);
    }
  }, {
    key: "acceptVisitor",
    value: function acceptVisitor(visitor) {
      return visitor.visitMap(this);
    }
  }]);

  return MapDesc;
}(ParsedDesc_1.ParsedDesc);

exports.MapDesc = MapDesc;